import * as loadjs from 'loadjs'
import { LoadJsBundle } from '../enums/LoadJsBundle'
import { domReady, isBelowViewport } from '../helpers/DOM'
import Logger from '../helpers/Logger'
import WebModel, {
  optimizingForDesktopPagespeed,
  optimizingForMobilePagespeed
} from '../models/WebModel'
import PrebidFacade from '../prebidFacade/PrebidFacade'
import SlotFactory from '../slots/SlotFactory'
import SlotRepository from '../slots/SlotRepository'
import { TimeoutValue } from '../slots/helpers/Timeout'

/**
 * ATF class
 * Responsible for displaying ATF slots
 */
export default class ATF {
  constructor(
    model: WebModel,
    readonly slotFactory: SlotFactory,
    readonly prebidFacade: PrebidFacade
  ) {
    domReady(() => {
      for (const slotModel of model.slots) {
        if (slotModel.lazy) {
          continue
        }

        if (shouldDisableSlotForPagespeed(slotModel)) {
          Logger.debug(
            `${slotModel.adUnitId} disabled for Desktop Pagespeed Optimization`
          )
          continue
        }

        this.slotFactory.new(slotModel)
      }

      const nonLazySlots = SlotRepository.all().filter((s) => !s.lazy)
      const allTimeouts = nonLazySlots.map((slot) => slot.timeout.value)
      const timeout = Math.max(...allTimeouts) as TimeoutValue

      prebidFacade.requestBids(nonLazySlots, timeout).then(() => {
        loadjs.done(LoadJsBundle.nonLazyRequestsLoaded)
      })

      // Trigger after 5 seconds in case ATF ads take too long
      const fiveSecs = 5000
      setTimeout(() => {
        loadjs.done(LoadJsBundle.nonLazyRequestsLoaded)
      }, fiveSecs)
    })
  }
}

function shouldDisableSlotForPagespeed(slotModel: ISlotModel): boolean {
  return (
    (optimizingForDesktopPagespeed() || optimizingForMobilePagespeed()) &&
    !isBelowViewport(slotModel)
  )
}
